<script setup lang="ts">
import { useLayoutLoader } from '@/composables/useLayoutLoader'

const { isLoading: loading } = useLayoutLoader()
</script>

<template>
  <div>
    <!-- 👉 Header  -->
    <Header />

    <!-- 👉 Mobile Menu  -->
    <MobileMenu />

    <!-- 👉 Main content area with sidebar and router view -->
    <div class="mt-16 lg:mt-[124px] custom-padding">
      <LayoutLoader :loading="loading">
        <!-- 👉 Sidebar (fixed below header, start/right side) -->
        <Sidebar class="fixed hidden lg:flex w-[170px] top-[124px] start-6 z-40" />
        <!-- 👉 Content -->
        <div class="lg:ms-[194px]">
          <RouterView v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </RouterView>
        </div>
      </LayoutLoader>
    </div>
  </div>
</template>
